<template>
  <div class="search" v-if="show">
    <div class="search-wrap">
      <div class="search-input">
        <i class="icon iconfont icon-search"></i>
        <form action="javascript:return true;" style="width:4rem">
            <input type="search" v-model="searchContent" :placeholder="placeholder" @keyup.13="sendSearch(0)">
        </form>
        <i class="icon iconfont icon-closec" v-if="searchContent" @click="searchContent=''"></i>  
      </div>
      <span class="search-btn" :class="{active: searchContent}" @click="sendSearch(0)">Search</span>
    </div>
    <div class="search-item" v-if="type && histroyList[type].length">
      <p class="search-title">
        <span>history</span>
        <i class="icon iconfont icon-trash" @click="histroyList[type]=[]"></i>
      </p>
      <span class="search-brand" v-for="(histroy, index) in histroyList[type]" :key="'histroy' + index" @click="setSearchTxt(histroy, 0)">{{histroy}}</span> 
    </div>
    <!-- <div class="search-item" v-if="type && type === 'CompInfo' && hallList.length">
      <p class="search-title">
        <span>按展馆搜索</span>
      </p>
      <span class="search-brand" v-for="(hall, index) in hallList" :key="'hall' + index" @click="setSearchTxt((hall.name  + ':' + hall.description), 1)">{{hall.name + ':'}} {{hall.description}}</span> 
    </div> -->
    <div class="search-item z-bottom" v-if="type && type === 'CompInfo' && categoryList && categoryList.length">
      <p class="search-title">
        <span>Category</span>
        <i class="icon iconfont icon-trash" @click="categoryList[type]=[]"></i>
      </p>
      <span class="search-brand" v-for="(category, index) in categoryList" :key="'category' + index" @click="setSearchTxt(category.nameEn, 2)">{{category.nameEn}}</span> 
    </div>
  </div> 
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";

export default { // 搜索页面
  props: { 
    show: {
      default: false
    },
    type: {
      default: 'CompInfo'
    },
    placeholder:{
        type:String,
    }
  },
  data () {
    return {
      histroyList: { // 历史记录
        CompInfo: [],
        Product: [],
        Activity: [],
      },
      hotList: [], // 热搜
      hallList: [], // 展馆搜索
      searchContent: '', // 搜索内容
    };
  },   
  watch: { 
    show: function() {
        console.log(this.show,'this.show')
    },
    searchBy: function() {
      if (this.searchBy) { 
        this.searchContent = '';
      }
    },
  },
  computed: {
    ...mapGetters({
        search: "getSearch",  
        searchBy: "getSearchBy", 
        categoryList:'getCategory',
    }), 
  },
  async created() {
    this.hallList = await this.$Myapollo.getHall(this);
  },
  methods: {
    ...mapMutations({
      setSearchBy: "setSearchBy",
      setSearch: "setSearch",
    }),
    setSearchTxt(txt, type = 0) { 
      console.log(txt,'txttttttt')
      if (txt.trim()) {
        this.searchContent = txt.trim(); 
        this.sendSearch(type);
      }
    },
    sendSearch(type) {
      let txt = this.searchContent.trim();
      let txt2 = txt.split(':');
      if (txt && this.histroyList[this.type].indexOf(txt) === -1) {
        this.histroyList[this.type].push(txt);
      }
      if (type !== 0) {
        this.searchContent = '';
      }
      this.$emit('callback', {txt: txt2[0], type: type}); 
      if (txt2[0]) { this.setSearchBy(''); }
      this.setSearch(txt2[0]);
      console.log(this.histroyList,'历史记录')
      this.hotList = [];
    }, 
  },
}

</script>

<style scoped lang='scss'>
input[type=search]::-webkit-search-cancel-button{
    -webkit-appearance: none;
}
.search {
  position: fixed;
  z-index: 1501;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 12px 15px 15px;
  overflow: auto;
  &-wrap {
    display: flex; 
    align-items: center;
  }
  &-btn {
    width: 36px;
    font-size: 14px;
    color: #333;
    text-align: right;
    align-items: center;
    margin-left: 0.35rem;
    &.active {
      color: #1890ff;
    }
  }
  &-input {
    background-color: #fff; 
    color: #b2b2b2; 
    border: 1px solid #e6e6ea;
    border-radius: 3px; 
    display: flex;
    align-items: center;
    background-color: #f4f4f4;
	  border-radius: 0.3rem;
    width: 5.6rem;
    .icon-search {
      font-size: 25px;  
      font-weight: 600;
      padding: 0 8px 0 10px;
      display: inline-block;
    }
    input {
      flex: 1;
      font-size: 14px;
      width: 100%;
      height: 35px;
      padding: 11px 10px 11px 0; 
      border: none;
      outline: none; 
      background-color: #f4f4f4;
      color: #333;
      &:hover,&:active,&:focus {
        border: none;
        outline: none; 
      }
    }
  }
  &-item { 
    padding-bottom: 12.5px;
    border-bottom: 1px solid #e6e6e6;
    &.z-bottom {
      border-bottom: 0px;
    }
  }
  &-title {
    font-size: 13px; 
    color: #333;
    padding: 13px 0 9px;
    display: flex;
    align-items: center;
    span { flex: 1; }
    .icon { 
      align-self: flex-end;
      font-size: 20px;
    }
    .hot-icon {
      width: 11px;
      height: 15px;
      display: inline-block;
      margin-left: 7px;
    }
  } 
  &-brand { 
    display: inline-block;
    padding: 4px 0.25rem;
    margin-bottom: 10px;
    line-height: 1.5em;
    color: #000;
    font-size: 14px;
    margin-right: 5px;
    background-color: #f4f4f4;
	  border-radius: 27px;
    border: solid 1px #e6e6e6;

    text-align: justify;
  }
  .icon-closec {
    font-size: 20px;
    color: #999;
    padding: 0 8px;
  }
}
</style> 